<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title appLifecycleTracker trackerName="move-user-dialog">{{ 'ADM_MOVE_USER_HEADER' | translate }}</h2>

<mat-dialog-content>
    <p>{{ 'ADM_MOVE_USER_NOTES' | translate }}</p>
    <mat-form-field class="user-selection" appearance="outline">
        <mat-label>{{'USER' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedUser">
            <mat-option *ngFor="let user of users" [value]="user">{{ user.username }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="user-selection" appearance="outline">
        <mat-label>{{'ADM_NEW_GROUP' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedGroup">
            <mat-option *ngFor="let group of groups" [value]="group">{{ group.name }}</mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onCancelClick()" type="button">{{ 'CANCEL_CAP' | translate }}</button>
    <button mat-raised-button (click)="onSubmit()" type="button" color="primary">{{ 'SAVE_CAP' | translate }}</button>
</div>
